<template>
    <div class="login-nav-bar">
        <div class="nav-buttons-wrapper">
            <a href="/" title="Home">
                <img class="nav-heder-icon" :src="homeIcon"/>
            </a>
            <div class="navs-wrapper">
                <a href="/app/sign-up/role" @click="handleClickSignup">
                    <span class="nav-button">Sign up</span>
                </a>
                <a href="/auth/login">
                    <span class="nav-button" @click="handleClickLogin">Login</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import RTGoogleAnalyticsManager from 'common/RTGoogleAnalyticsManager';

export default {
  props: ['homeIcon'],
  methods: {
    handleClickSignup() {
      RTGoogleAnalyticsManager.sendEvent('top_menu', 'clicked_sign-up', location.pathname);
    },
    handleClickLogin() {
      RTGoogleAnalyticsManager.sendEvent('top_menu', 'clicked_login', location.pathname);
    }
  }
}
</script>

<style scoped lang="scss">

@import './navigation';

.login-nav-bar {
  height: 80px;

  .nav-button {
    cursor: pointer;
    color: $title-dark-grey;
    padding: 9px 26px;
    margin: 15px 8px;
    border: 2px solid #ddd;
    border-radius: 20px;

    &:hover {
      background: #d3d3d3;
      border-color: transparent;
    }
  }
}

@media (max-width: 767px) {
  .login-nav-bar {
    display: flex !important;
    .nav-heder-icon {
      width: 31px;
    }
    .navs-wrapper {
      a {
        white-space: nowrap;
        &:first-child {
          .nav-button {
            margin-right: 0;
          }
        }
      }
    }
  }
}

</style>
